export const STATUS_ARCHIVE = 'arsip';
export const STATUS_CONCEPT = 'konsep';
export const STATUS_DRAFT = 'draft';
export const STATUS_ACCEPT = 'acc';
export const STATUS_REVISION = 'revisi'; // belum dipakai
export const STATUS_TRASH = 'sampah';
export const STATUS_PROCCESS = 'proses';
export const STATUS_SEND = 'terkirim'; // butuh dipikirkan apakah status ini perlu, karena status ini bawaan digof legacy
